import { object, string, date, array } from '@/_config/lib/yup';
import type { BillingType, IStatusOption } from './types';

export const STATUS_OPTIONS: Array<IStatusOption> = [
  {
    key: 'PENDENTE',
    text: 'PENDENTE',
    value: 'PENDENTE',
  },
  {
    key: 'ASSOCIADO',
    text: 'ASSOCIADO',
    value: 'ASSOCIADO',
  },
  {
    key: 'ACEITO',
    text: 'ACEITO',
    value: 'ACEITO',
  },
  {
    key: 'CANCELADO',
    text: 'CANCELADO',
    value: 'CANCELADO',
  },
  {
    key: 'CHEGOU_NA_LOJA',
    text: 'CHEGOU NA LOJA',
    value: 'CHEGOU_NA_LOJA',
  },
  {
    key: 'SAIU_DA_LOJA',
    text: 'SAIU DA LOJA',
    value: 'SAIU_DA_LOJA',
  },
  {
    key: 'CHEGOU_NO_CLIENTE',
    text: 'CHEGOU NO CLIENTE',
    value: 'CHEGOU_NO_CLIENTE',
  },
  {
    key: 'PERSONALIZAR_CORRIDA',
    text: 'PERSONALIZAR CORRIDA',
    value: 'PERSONALIZAR_CORRIDA',
  },
  {
    key: 'ENTREGUE',
    text: 'ENTREGUE',
    value: 'ENTREGUE',
  },
  {
    key: 'FINALIZADO',
    text: 'FINALIZADO',
    value: 'FINALIZADO',
  },
];

export const GET_DELIVERIES_LIST = 'GET_DELIVERIES_LIST';
export const GET_DELIVERY_DETAIL = 'GET_DELIVERY_DETAIL';

export const DELIVERIES_FORM_SHECMA = object({
  motoboyId: string().optional(),
  motoboyName: string().optional(),
  deliveryId: string().objectId().optional(),
  placeId: string().optional(),
  placeName: string().optional(),
  code: string().optional(),
  cityId: string().optional(),
  deliveryType: string().optional(),
  startDate: date(),
  endDate: date(),
  status: array(string()).optional(),
  billingType: string().optional(),
});

export enum ENUM_ORIGIN_ORDER_TYPE {
  QD = 'QD',
  WHATSAPP = 'WHATSAPP',
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  IFOOD = 'IFOOD',
  TELEFONE = 'TELEFONE',
  OUTROS = 'OUTROS',
  COMPRE_SEM_FILA = 'COMPRE_SEM_FILA',
  QD_API_GERAL = 'QD_API_GERAL',
}

export enum ENUM_DELIVERY_TYPE {
  LINKED = 'LINKED',
  CLOUD = 'CLOUD',
}

const LINKED_AND_CLOUD_TYPE = 'LINKED_AND_CLOUD';

export const TRANSLATE_DELIVERY_TYPE: Record<
  ENUM_DELIVERY_TYPE | typeof LINKED_AND_CLOUD_TYPE,
  string
> = {
  [ENUM_DELIVERY_TYPE.LINKED]: 'Próprio',
  [ENUM_DELIVERY_TYPE.CLOUD]: 'Nuvem',
  LINKED_AND_CLOUD: 'Transbordo',
};

export const TRANSLATE_BILLING_TYPE: Record<BillingType, string> = {
  POST_PAID: 'Pós-pago',
  PRE_PAID: 'Pré-pago',
};

export const TYPE_DELIVERY_OPTIONS = [
  {
    key: ENUM_DELIVERY_TYPE.CLOUD,
    text: TRANSLATE_DELIVERY_TYPE.CLOUD,
    value: ENUM_DELIVERY_TYPE.CLOUD,
  },
  {
    key: ENUM_DELIVERY_TYPE.LINKED,
    text: TRANSLATE_DELIVERY_TYPE.LINKED,
    value: ENUM_DELIVERY_TYPE.LINKED,
  },
];

export const BILLING_TYPE_OPTIONS = [
  {
    key: 'PRE_PAID',
    text: TRANSLATE_BILLING_TYPE.PRE_PAID,
    value: 'PRE_PAID',
  },
  {
    key: 'POST_PAID',
    text: TRANSLATE_BILLING_TYPE.POST_PAID,
    value: 'POST_PAID',
  },
];

export const GET_MOTOBOYS = 'GET_MOTOBOYS';
export const GET_PLACES_BY_NAME = 'GET_PLACES_BY_NAME';
export const GET_ENTREGADORES_BY_ASSOCIATE = 'GET_ENTREGADORES_BY_ASSOCIATE';

export const TIME_MILLISECONDS_REFETCH = 60000;

export const ORIGIN_ORDER_TYPE_LABELS: Record<ENUM_ORIGIN_ORDER_TYPE, string> =
  {
    [ENUM_ORIGIN_ORDER_TYPE.QD]: 'Quero Delivery (manual)',
    [ENUM_ORIGIN_ORDER_TYPE.WHATSAPP]: 'WhatsApp',
    [ENUM_ORIGIN_ORDER_TYPE.INSTAGRAM]: 'Instagram',
    [ENUM_ORIGIN_ORDER_TYPE.FACEBOOK]: 'Facebook',
    [ENUM_ORIGIN_ORDER_TYPE.IFOOD]: 'iFood',
    [ENUM_ORIGIN_ORDER_TYPE.TELEFONE]: 'Telefone',
    [ENUM_ORIGIN_ORDER_TYPE.OUTROS]: 'Outros',
    [ENUM_ORIGIN_ORDER_TYPE.COMPRE_SEM_FILA]: 'Compre sem Fila',
    [ENUM_ORIGIN_ORDER_TYPE.QD_API_GERAL]: 'Quero Delivery (gestor de pedidos)',
  };
